import { useDispatch, useSelector } from "react-redux";
import clsx from "clsx";
import { isNull } from "lodash";
import useLanguageChange from "../../../../hooks/useLanguageChange";

import { GLOBAL_MEETING_DATA } from "../../../../constants/PublicVariables";
import { PARTICIPANT_TYPE } from "../../../../constants/InviteConstants";
import { TOAST_MESSAGE } from "../../../../constants/ToastMsgLocalize";

import { formatSessionID } from "../../../../shared/function";
import { CopyTextOrLinkToClipboard, generateInviteUrl } from "../../../../shared/utility";
import useGetNetworkQuality from "../../../../hooks/useGetNetworkQuality";
import { setIsSessionInfoOpen } from "../../../../reducers/common-reducer";
import { NQ_UNSTABLE_PARAM } from "../../../../constants/Constants";

const SessionInfoSidebar = () => {
    const { callDuration, isSessionInfoOpen, timerStarted, partiCountForDisplay, nqAvailable } = useSelector((state) => state.commonReducer);
    const { localUserNetworkQuality } = useSelector((state) => state.twilioEvents);
    const dispatch = useDispatch();

    /* custome hook for getting updated localized value object for entire project 
    This will give localize value object for selected language
    Also will give updated localized value object when language change*/
    const localisedValues = useLanguageChange();

    const localUserQualityValue = useGetNetworkQuality();

    const handleCloseSidebar = () => {
        dispatch(setIsSessionInfoOpen(false));
    };

    const handleCopyLink = () => {
        const value = generateInviteUrl(PARTICIPANT_TYPE.GUEST);
        CopyTextOrLinkToClipboard(value, localisedValues[TOAST_MESSAGE.GUEST_URL_COPY]);
    };

    return (
        <div className={clsx("sidebar session-info", isSessionInfoOpen && "active")} id='session-info-sidebar'>
            <div className='sidebar-in'>
                <div className='sidebar-head'>
                    {/* Session code and copy session ID button display */}
                    <div className='sidebar-head-title'>
                        <div className='title'>
                            {localisedValues["code"]}: {formatSessionID(GLOBAL_MEETING_DATA.sessionId)}
                            {GLOBAL_MEETING_DATA.isAgent && (
                                <div className='copy-session-id custom-tooltip center-tooltip tooltip-auto-width'>
                                    <button
                                        className='btn'
                                        onClick={() =>
                                            CopyTextOrLinkToClipboard(GLOBAL_MEETING_DATA.sessionId, localisedValues[TOAST_MESSAGE.SESSION_CODE_COPY])
                                        }
                                    >
                                        <span className='for-icon icon-copy-code'></span>
                                    </button>
                                    <div className='custom-tooltip-content text-nowrap'>
                                        <div className='custom-tooltip-in'>
                                            <p>{localisedValues["copy_session_code"]}</p>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    {/* close button */}
                    <div className='sidebar-head-right'>
                        <div className='sidebar-close'>
                            <button className='btn close-modal-btn close-info-sidebar-button' onClick={handleCloseSidebar}>
                                <span className='for-icon icon-close-light'></span>
                            </button>
                        </div>
                    </div>
                </div>
                <div className='sidebar-body'>
                    <div className='session-info-row'>
                        {/* call duration timer display */}
                        <div className='session-info-timer'>
                            {timerStarted && (
                                <>
                                    <span className='timer-label'>{localisedValues["duration"]}: </span>
                                    <span className='timer-value'>{callDuration}</span>
                                </>
                            )}
                        </div>

                        <div className='session-info-right'>
                            {/* Network quality display */}
                            {nqAvailable && (
                                <div className='session-network'>
                                    {isNull(localUserNetworkQuality) && <span className='for-close-icon icon-close'></span>}
                                    <div className='for-base-icon'>
                                        <span className='for-icon icon-network'></span>
                                    </div>
                                    {localUserNetworkQuality >= NQ_UNSTABLE_PARAM && (
                                        <div className='for-over-icon'>
                                            <span
                                                className='for-icon icon-network'
                                                style={{ width: localUserQualityValue?.percentage || "0%" }}
                                            ></span>
                                        </div>
                                    )}
                                    {!isNull(localUserNetworkQuality) && localUserNetworkQuality < NQ_UNSTABLE_PARAM && (
                                        <div className='for-over-icon'>
                                            <span className='for-icon icon-network danger-text'></span>
                                        </div>
                                    )}
                                </div>
                            )}
                            {/* Participant count display */}
                            <div className='session-info-participants custom-tooltip tooltip-auto-width'>
                                <div className='session-participants'>
                                    <span className='for-icon icon-user'></span>
                                    <span className='count'>
                                        <span className='count-in'>{partiCountForDisplay}</span>
                                    </span>
                                </div>
                                <div className='custom-tooltip-content text-nowrap'>
                                    <div className='custom-tooltip-in'>
                                        <p>{localisedValues["participant_connected"]?.replace("<participantCount>", partiCountForDisplay)}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* copy guest session URL link button display */}
                    {GLOBAL_MEETING_DATA.isAgent && (
                        <div className='session-link-copy'>
                            <button className='btn btn-link btn-with-icon text-dec-none' onClick={() => handleCopyLink()}>
                                <span className='btn-icon icon-copy-code'></span>
                                <span className='btn-text'>{localisedValues["copy_link_to_share"]}</span>
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default SessionInfoSidebar;
